import * as React from "react";
import * as ReactDOM from "react-dom";
import { Route } from "react-router-dom";
import * as moment from "moment";
import * as enums from "../../enumerations";
import * as modelsGet from "../../models/get";
import { Datepicker } from "../datepicker";
import { SideBarEvents } from "./sidebarEvents";

interface IProperties
{
    /**
     * Angabe, ob der Kalender aktualisiert werden soll.
     */
    refresh: boolean,

    /**
     * Angabe, ob die SideBar geöffnet ist.
     */
    isOpen: boolean,

    /**
     * Das momentan selektierte Datum.
     */
    selectedDate: moment.Moment,

    /**
     * Die momentan selektierte Kalenderansicht.
     */
    selectedViewMode: enums.CalendarViewMode,

    /**
     * Die Breite der SideBar.
     */
    width?: number,

    /**
     * Anzahl der sichtbaren Datepicker.
     */
    visibleDatepickerCount?: number,

    /**
     * Wird ausgeführt, sobald die SideBar ausgeklappt wird.
     */
    onExpanded?: () => void,

    /**
     * Wird ausgeführt, sobald die SideBar eingeklappt wird.
     */
    onCollapsed?: () => void,

    /**
     * Wird ausgeführt, sobald ein Datepicker hinzugefügt wird.
     */
    onDatepickerAdded?: (newCount: number) => void,

    /**
     * Wird ausgeführt, sobald ein Datepicker entfernt wird.
     */
    onDatepickerRemove?: (newCount: number) => void,

    /**
     * Wird ausgeführt, sobald sich das Datum des Datepickers ändert.
     */
    onDateChanged?: (newDate: moment.Moment, type: string, history: any) => void,

    /**
     * Wird ausgeführt sobald sich das Popup für die Termindetails öffnet.
     * @param e Das auslösende Ereignis.
     * @param event Der gebundene Termin.
     */
    onEventDetailsPopupOpening?: (e: MouseEvent, appoiontment: modelsGet.IAppointment) => boolean
}

export class SideBar extends React.Component<IProperties>
{
    /**
     * Standardwerte setzen.
     */
    public static defaultProps: Partial<IProperties> = {
        visibleDatepickerCount: 1
    };

    /**
     * Erstellt eine neue Instanz der Klasse @see SideBar.
     * @param props Die Eigenschaften dieser Komponente.
     */
    constructor(props: IProperties)
    {
        super(props);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const {
            refresh,
            isOpen,
            selectedDate,
            selectedViewMode,
            width,
            visibleDatepickerCount,
            onExpanded,
            onCollapsed,
            onDatepickerAdded,
            onDatepickerRemove,
            onDateChanged,
            onEventDetailsPopupOpening
        } = this.props;

        if (!isOpen)
        {
            return (
                <div
                    className="calendar-sidebar-collapsed"
                    onClick={onExpanded}>
                    <i className="mdi mdi-arrow-collapse-right"></i>
                </div>
            );
        }
        else
        {
            const Dp = () => (
                <Route render={({ history }) => (
                    <Datepicker
                        selectedDate={selectedDate}
                        selectedViewMode={selectedViewMode}
                        count={visibleDatepickerCount}
                        isSelectedRangeVisible
                        onDateChanged={(newDate, type) => onDateChanged && onDateChanged(newDate, type, history)} />
                )} />
            );

            return (
                <div
                    className="calendar-sidebar"
                    style={{
                        width: width
                    }}>
                    <Dp />
                    <SideBarEvents
                        refresh={refresh}
                        onEventDetailsPopupOpening={onEventDetailsPopupOpening} />
                    <div
                        className="calendar-sidebar_collapse-btn"
                        onClick={onCollapsed}>
                        <i className="mdi mdi-arrow-collapse-left"></i>
                        <span className="calendar-sidebar_collapse-btn_text">Einklappen</span>
                    </div>
                </div>
            );
        }
    }
}